import {type} from '../../common/utils';
import {ActionLocal} from './actions.service';
import {IProjectTypeSelector} from "../../models/common";

export class ApplicationProjectTypeActions {

  static ActionType = {
      LOAD: type('[ApplicationProjectTypeActions] LOAD'),
      LOADED: type('[ApplicationProjectTypeActions] LOADED'),
      LOAD_ERROR: type('[ApplicationProjectTypeActions] LOAD ERROR'),
      LOADED_APP_MAP: type('[ApplicationProjectTypeActions] LOADED APP MAP'),
      LOAD_APP_MAP_ERROR: type('[ApplicationProjectTypeActions] LOAD APP MAP ERROR'),
      SET_BREADCRUMB: type('[ApplicationProjectTypeActions] SET_BREADCRUMB')
  };

  public static loadProjectTypes(): ActionLocal {
    return {type: ApplicationProjectTypeActions.ActionType.LOAD};
  }

  public static setBreadCrumbItems(item: IProjectTypeSelector[]): ActionLocal {
    return {type: ApplicationProjectTypeActions.ActionType.SET_BREADCRUMB, payload: item};
  }

  public static loadedProjectTypes(item: IProjectTypeSelector[]): ActionLocal {
    return {type: ApplicationProjectTypeActions.ActionType.LOADED, payload: item};
  }

  public static loadedError(err: string): ActionLocal {
    return {type: ApplicationProjectTypeActions.ActionType.LOAD_ERROR, payload: err};
  }

  public static loadedAppTypesMap(item: IProjectTypeSelector[]): ActionLocal {
    return {type: ApplicationProjectTypeActions.ActionType.LOADED_APP_MAP, payload: item};
  }

  public static loadedAppTypesMapError(err: string): ActionLocal {
    return {type: ApplicationProjectTypeActions.ActionType.LOAD_APP_MAP_ERROR, payload: err};
  }

}
